GT.MegaMenuV3 = function() {
    // State management
    const state = {
        isDesktop: GT.isDesktopView(),
        closeTimers: [],
        activeMenuTier2: null
    };

    // DOM Elements
    const elements = {
        html: document.firstElementChild,
        header: GT.headerElm,
        headerMenu: document.querySelector('.header-menu'),
        linkLv1: document.querySelectorAll('.nav-link, .global-search__toggle, .global-reach__toggle'),
        closeMegaIcons: document.querySelectorAll('.close-mega__menu'),
        toggleButtons: document.querySelectorAll('.mega__level--3__toggle')
    };

    // Constants
    const ANIMATION_DELAYS = {
        TRIGGER: 150,
        SCROLL: 600,
        SEARCH_FOCUS: 500
    };

    // Utility Functions
    const utils = {
        promoteArticle() {
            const featuredMega = document.querySelector('.mega__level--3.open');
            if (!featuredMega) return;

            featuredMega.querySelectorAll('.article-tile').forEach(article => {
                if (!article) return;
                const header = article.querySelector('.article-tile__header');
                const content = article.querySelector('.article-tile__content-container');
                article.style.height = header.getBoundingClientRect().height + content.getBoundingClientRect().height + 'px';
            });

            setTimeout(() => GT.clampArticle(true), 200);
        },

        resetTabIndexes(elements, value) {
            elements.forEach(element => element.setAttribute('tabindex', value));
        },

        setAriaExpanded(element, value) {
            if (element.classList.contains('nav-link--dropdown')) {
                element.setAttribute('aria-expanded', value);
            }
        }
    };

    // Menu Management
    const menuManager = {
        //isFastClose: true if the close is triggered by a fast action (mouseenter), not really close, just reset the state
        closeSecondary(isFastClose) {
            if (elements.html.classList.contains("global-reach--opening") || 
                elements.header.querySelector(".menu-link.open") || 
                !elements.html.classList.contains("opening-header-overlay")) return;

            // Reset classes
            if (!elements.html.classList.contains("opening-mobile-menu")) {
                elements.html.classList.remove("opening-megamenu", "global-search--opening", "show-extra-menu");
            }

            if(state.isDesktop)
                GT.Overlays.hideHeaderOverlay();

            // Handle animation timing
            state.closeTimers.push(setTimeout(() => {
                if (!elements.html.classList.contains("global-reach--opening")) {
                    elements.header.querySelector(".bleed.trigger-animation")?.classList.remove("trigger-animation");
                }
            }, 80));

            // Reset bleed items
            elements.header.querySelectorAll(".bleed.open, .bleed .open").forEach(bleedItem => {
                if(!bleedItem.classList.contains("bleed") && bleedItem.querySelector("li:not(.mega-link--level-2-placeholder) > a.mega-link--level-3.selected")) return;
                bleedItem.classList.remove("open");
                utils.resetTabIndexes(bleedItem.querySelectorAll('a'), -1);
                
                bleedItem.querySelectorAll('.mega__level--2-group').forEach(group => {
                    group.removeAttribute('tabindex');
                    if (group.getAttribute('aria-expanded') === 'true') {
                        group.setAttribute('aria-expanded', 'false');
                    }
                });
            });

            // Reset navigation links
            elements.linkLv1.forEach(item => {
                item.classList.remove('open');
                item.removeAttribute('tabindex');
                utils.setAriaExpanded(item, 'false');
            });

            // Reset mega level 2 items
            elements.header.querySelectorAll(".mega__level--2.open").forEach(lv2Item => {
                lv2Item.classList.remove("open");
            });

            elements.header.style.setProperty('--bleed-height', 0);

            if(!isFastClose) {
                elements.header.classList.remove('show-background');
            }
        },
        
        openSecondary(panelId) {
            if (elements.html.classList.contains("global-reach--opening")) return;

            // Setup initial state
            GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
            elements.html.classList.add("opening-megamenu");
            GT.Overlays.showHeaderOverlay();
            state.closeTimers.forEach(clearTimeout);
            // Reset other menus
            menuManager.resetExtraMenus();

            // Handle bleed items
            const bleedItems = elements.header.querySelectorAll('.bleed');
            bleedItems.forEach(bleedItem => {
                menuManager.handleBleedItem(bleedItem, panelId);
            });

            setTimeout(() => utils.promoteArticle(), 100);
        },

        handleBleedItem(bleedItem, panelId) {
            bleedItem.classList.remove('open');
            if (bleedItem.getAttribute('data-content') === panelId) {
                menuManager.setupActiveBleed(bleedItem);
            }
        },

        setupActiveBleed(bleedItem) {
            const bleedHeight = bleedItem.querySelector(".bleed-container").offsetHeight;
            state.activeMenuTier2 = bleedItem;
            elements.header.style.setProperty('--bleed-height', 
                (GT.wHeight < bleedHeight && state.isDesktop ? GT.wHeight : bleedHeight) + 'px');
            
            bleedItem.classList.add('open');
            setTimeout(() => bleedItem.classList.add("trigger-animation"), ANIMATION_DELAYS.TRIGGER);
            menuManager.setupBleedAccessibility(bleedItem);
            setTimeout(() => {
                elements.header.classList.add('show-background');
            }, 600);
        },

        setupBleedAccessibility(bleedItem) {
            bleedItem.querySelectorAll(".bleed-container ul").forEach(ul => {
                ul.removeAttribute("role");
                ul.querySelectorAll("li").forEach(li => {
                    li.removeAttribute("role");
                });
            });

            if (state.isDesktop) {
                utils.resetTabIndexes(bleedItem.querySelectorAll('a'), 0);

                if (bleedItem.querySelector(".mega__level--2-group .first-level")) {
                    
                    bleedItem.querySelectorAll(".bleed-container ul").forEach(ul => {
                        ul.setAttribute("role", "none");
                        ul.querySelectorAll("li").forEach(li => {
                            li.setAttribute("role", "none");
                        });
                    });
                }
            } else {
                bleedItem.querySelectorAll('.mega__level--2-group').forEach(group => {
                    group.setAttribute('tabindex', 0);
                });
                
                bleedItem.querySelectorAll('a.mega-link--level-2, .bleed-container .group-title a.first-level')
                    .forEach(a => a.removeAttribute('tabindex'));
            }
        },

        resetExtraMenus() {
            const extraMenu = document.querySelector('.menu-link');
            if (extraMenu?.classList.contains('open')) {
                extraMenu.classList.remove('open');
                extraMenu.querySelector('button.nav-link')?.blur();
            }

            const globalSearch = document.querySelector('.global-search');
            if (globalSearch) {
                globalSearch.classList.remove('open');
                globalSearch.querySelector('input[name="q"]')?.blur();
            }
        }
    };

    // Event Handlers
    const eventHandlers = {
        handleNavOpenEvents(e) {
            const target = e.target;
            const isGlobalSearchBtn = target.closest('.global-search__toggle');
            const globalSearch = document.querySelector('.global-search');
            const globalSearchInput = globalSearch?.querySelector('input[name="q"]');

            if (target.classList.contains("open")) {
                if (e.type === "click") {
                    menuManager.closeSecondary();
                }
                return;
            } else {
                if((!isGlobalSearchBtn && !state.isDesktop && !target.closest('.global-reach__toggle')) || state.isDesktop) {
                    menuManager.closeSecondary(true);
                }
            }

            if (this.classList.contains('nav-link--dropdown') && this.getAttribute('aria-expanded') === 'false') {
                if ((isGlobalSearchBtn && e.type !== "click") || elements.html.classList.contains("global-reach--opening")) return;
                
                this.classList.add('open');
                menuManager.openSecondary(this.getAttribute('data-open'));
                this.setAttribute('aria-expanded', 'true');

                if (!state.isDesktop) {
                    setTimeout(() => {
                        target.scrollIntoView({behavior: 'auto', block: 'nearest', inline: 'start'});
                    }, ANIMATION_DELAYS.SCROLL);
                }

                if (!GT.isMobileCached) {
                    utils.resetTabIndexes(elements.linkLv1, -1);
                    this.removeAttribute('tabindex');
                }

                if (isGlobalSearchBtn && globalSearchInput) {
                    globalSearchInput.click();
                    setTimeout(() => globalSearchInput.focus(), ANIMATION_DELAYS.SEARCH_FOCUS);
                }
            }
        },

        keypressNav(e) {
            const keyHandlers = {
                Tab: () => eventHandlers.handleTabKey(e),
                Escape: () => eventHandlers.handleEscapeKey(e)
            };

            const handler = keyHandlers[e.key];
            if (handler) {
                handler();
            }
        },

        handleTabKey(e) {
            if (GT.isMobileCached) return;

            const target = e.currentTarget;
            if (target.classList.contains('nav-link')) {
                eventHandlers.handleNavLinkTab(e, target);
            }

            const openBleed = target.closest('.bleed.open');
            if (openBleed) {
                eventHandlers.handleBleedTab(e, target, openBleed);
            }

            if (target.classList.contains('global-search__toggle') && 
                target.getAttribute('aria-expanded') === 'true') {
                eventHandlers.handleSearchTab(e);
            }
        },

        handleNavLinkTab(e, target) {
            if (e.shiftKey) {
                eventHandlers.handleShiftTabNav(e, target);
            } else if (target.getAttribute('aria-expanded') === 'true') {
                eventHandlers.handleForwardTabNav(e, target);
            }
        },

        handleShiftTabNav(e, target) {
            e.preventDefault();
            if (target.getAttribute('aria-expanded') === 'true') {
                const dataOpen = target.getAttribute('data-open');
                const openBleed = document.querySelector(`.bleed.open[data-content="${dataOpen}"]`);
                const focusItems = openBleed?.querySelectorAll('.mega-link, span.first-level, input, a, button');
                
                if (focusItems?.length) {
                    utils.resetTabIndexes(focusItems, 0);
                    focusItems[focusItems.length - 1]?.focus();
                    return;
                }
            }
            
            const previousLi = target.closest('li').previousElementSibling;
            if (previousLi) {
                previousLi.querySelector('.nav-link--dropdown, .nav-link')?.focus();
            } else {
                document.querySelector('header .desktop-logo')?.focus();
            }
        },

        handleForwardTabNav(e, target) {
            e.preventDefault();
            const dataOpen = target.getAttribute('data-open');
            const openBleed = document.querySelector(`.bleed.open[data-content="${dataOpen}"]`);
            const focusItems = openBleed?.querySelectorAll('.mega-link, span.first-level, input, a, button');
            
            focusItems?.forEach(item => item.setAttribute('tabindex', 0));
            focusItems?.[0]?.focus();
        },

        handleBleedTab(e, target, openBleed) {
            const allCurrentBleedLinks = openBleed.querySelectorAll('a, button, [tabindex="0"]');
            const lastLink = allCurrentBleedLinks?.[allCurrentBleedLinks.length - 1];
            
            if (lastLink && target === lastLink && !e.shiftKey) {
                e.preventDefault();
                eventHandlers.focusOnNavDropdown(target);
            }
        },

        handleSearchTab(e) {
            e.preventDefault();
            const globalSearch = document.querySelector('.global-search');
            const searchOverlayInput = globalSearch?.querySelector('#searchField');
            
            if (e.shiftKey) {
                const searchResultLinks = globalSearch?.querySelectorAll('.search-overlay__contents a');
                const lastSearchLink = searchResultLinks?.[searchResultLinks.length - 1];
                (lastSearchLink || searchOverlayInput)?.focus();
            } else {
                searchOverlayInput?.focus();
            }
        },

        handleEscapeKey(e) {
            const currentTarget = e.currentTarget;
            const currentNavLink = currentTarget.closest('.nav-link--dropdown');
            const triggerNavLink = currentNavLink ? currentNavLink : document.querySelector(`.nav-link--dropdown[data-open="${currentTarget.closest('.bleed')?.getAttribute('data-content')}"]`);
            
            if(!triggerNavLink) return;

            const focusItems = elements.headerMenu?.querySelectorAll('.mega-link, .mega-link--level-2, .first-level, input, a, button');
            utils.resetTabIndexes(focusItems, -1);

            menuManager.closeSecondary();
            triggerNavLink.focus();
        },

        focusOnNavDropdown(element) {
            const currentBleed = element.closest('.bleed');
            currentBleed.querySelectorAll('.mega-link, .first-level, input, a')?.forEach(item => {
                item.setAttribute('tabindex', -1);
            });
            const currentNavLink = element.closest('.bleed').closest('li')?.querySelector('.nav-link--dropdown');
            currentNavLink?.focus();
        }
    };

    // Event Registration
    function registerEvents() {
        const registerNavEvents = () => {
            elements.linkLv1.forEach(navLevel1 => {
                if (!state.isDesktop) {
                    navLevel1.removeEventListener("mouseenter", eventHandlers.handleNavOpenEvents);
                    navLevel1.removeEventListener("click", eventHandlers.handleNavOpenEvents);
                    navLevel1.addEventListener("click", eventHandlers.handleNavOpenEvents);
                } else {
                    navLevel1.removeEventListener("click", eventHandlers.handleNavOpenEvents);
                    navLevel1.removeEventListener("mouseenter", eventHandlers.handleNavOpenEvents);
                    if (!GT.isTouchDevice) {
                        navLevel1.addEventListener("mouseenter", eventHandlers.handleNavOpenEvents);
                    }
                    navLevel1.addEventListener("keydown", eventHandlers.keypressNav);
                    navLevel1.addEventListener("click", eventHandlers.handleNavOpenEvents);
                }
            });
        };

        const registerSubMenuEvents = () => {
            document.querySelectorAll('.header-menu-wrapper .mega-link, .header-menu-wrapper .first-level, button')
                .forEach(item => item.addEventListener('keydown', eventHandlers.keypressNav));
        };

        const registerCloseEvents = () => {
            elements.closeMegaIcons.forEach(icon => {
                icon.addEventListener("click", () => {
                    document.querySelector('.nav-link.open')?.focus();
                    menuManager.closeSecondary();
                });
                icon.addEventListener('keydown', eventHandlers.keypressNav);
            });
        };

        const registerArticleTileEvents = () => {
            document.querySelectorAll('.mega-wrapper .article-tile')
                .forEach(item => item.addEventListener('keydown', eventHandlers.keypressNav));
        };

        const registerOutsideClickEvents = () => {
            if (!state.isDesktop) return;

            document.addEventListener('mouseup', (e) => {
                if (!elements.header.contains(e.target) && 
                    !e.target.classList.contains("nav-link--dropdown") && 
                    state.isDesktop) {
                    menuManager.closeSecondary();
                }

                const langDropdown = document.querySelector(".header-lang");
                if (langDropdown && !langDropdown.contains(e.target)) {
                    langDropdown.classList.remove("open");
                }
            });

            if (elements.header) {
                elements.header.querySelector(".main-header")?.addEventListener("mouseleave", () => {
                    if (state.isDesktop) {
                        menuManager.closeSecondary();
                    }
                });
            }
        };

        registerNavEvents();
        registerSubMenuEvents();
        registerCloseEvents();
        registerArticleTileEvents();
        registerOutsideClickEvents();
    }

    // Initialization
    function init() {
        GT.windowResizeFncList.desktopMegaMenuV3 = () => {
            state.isDesktop = GT.isDesktopView();
            menuManager.closeSecondary();
            registerEvents();
            utils.promoteArticle();
        };

        registerEvents();

        elements.toggleButtons.forEach(button => {
            button.addEventListener("click", (e) => {
                const listing = button.previousElementSibling;
                if (!listing || (e.key && e.key !== 'Enter')) return;
                listing.classList.toggle('open');

                const listingState = listing.classList.contains('open');
                button.setAttribute('aria-expanded', listingState);
                setTimeout(() => {
                    menuManager.setupActiveBleed(listing.closest('.bleed'));
                    if(listingState) {
                        listing.querySelector("li:not(.mega-link--level-2-placeholder) > a").focus();
                    } else {
                        // Scroll to the LV2 element
                        listing.previousElementSibling.scrollIntoView({behavior: 'auto', block: 'nearest'});
                    }
                }, 600);
            });
        });
    }

    // Public API
    return {
        init: init,
        closeSecondary: menuManager.closeSecondary
    };
}

// Initialize on DOM content loaded
GT.domContentLoadedFncList.push(() => {
    GT.MegaMenuV3 = GT.MegaMenuV3();
    GT.MegaMenuV3.init();
});
GT.MobileMenuV3 = function () {

    if(typeof isNav3 == "undefined") return;

    let toggleMenuBtns = GT.headerElm.querySelectorAll(".menu-toggle"),
        htmlElm = document.firstElementChild;
    
    const searchInput = GT.headerElm.querySelector('.global-search input[name="q"]');
    const classOpeningMegaMenu = "opening-megamenu";
    const classOpeningMobileMenu = "opening-mobile-menu";
    const classOpeningMobileSearch = "opening-mobile-search";
    const primaryMenu = GT.headerElm.querySelector(".primary-menu");
    const primaryMenuFirstItem = primaryMenu?.querySelector('a, button');

    function activateSearchInput() {
        const newInput = document.createElement('input');
        newInput.style = 'position: absolute; top: 0; left: 0; opacity: 0; height:0;';
        searchInput.parentNode.insertBefore(newInput, searchInput.nextSibling);

        setTimeout(e => {
            searchInput.focus();
        }, 500)
        setTimeout(() => {
            newInput.remove();
        }, 1000);
    }

    function toggleRoleToPrimaryMenu(isAdding = true) {
        const primaryMenu = htmlElm.querySelector(".primary-menu");
        if(!primaryMenu) return;
        isAdding ? primaryMenu.setAttribute("role", "none") : primaryMenu.removeAttribute("role");
    }

    toggleMenuBtns.forEach(btn => {
        btn.addEventListener("click", e => {
            const currentMenuToggleBtn = e.target.closest(".menu-toggle");
            const searchToggleBtn = currentMenuToggleBtn.closest(".mobile-search-toggle");
            const onPageNav = htmlElm.querySelector(".onpage-navigation");

            function isOpening() {
                return htmlElm.classList.contains("opening-megamenu");
            }

            const currentStateIsOpening = isOpening();

            // Reset expanded state on all toggle buttons
            toggleMenuBtns.forEach(btn => btn.setAttribute("aria-expanded", false));

            // Handle onpage navigation if expanded
            if (onPageNav?.classList.contains("expanded")) {
                htmlElm.classList.remove("showing-overlay");
                onPageNav.classList.remove("expanded");
            }

            // Handle search toggle
            if (searchToggleBtn) {
                handleSearchToggle(searchToggleBtn, currentStateIsOpening);
            } else {
                handleMenuToggle(currentMenuToggleBtn, currentStateIsOpening); 
            }

            // Handle overlay and scroll behavior
            if (!currentStateIsOpening) {
                // GT.lockScrollBehindOverlay(".header-menu-wrapper"); // cannot scroll on global search V3
                GT.Overlays.showHeaderOverlay();
                !searchToggleBtn && initializedMegaMenuLv2();
            } else {
                setTimeout(() => {
                    if(!isOpening()) {
                        GT.Overlays.hideHeaderOverlay();
                    }
                }, 100);
            }
        });
    });

    function handleSearchToggle(searchToggleBtn, isOpening) {
        if (!isOpening) {
            GT.SearchOverlayV3.triggerInitializeSearchOverlay();
            // Opening search for first time
            htmlElm.classList.add(classOpeningMegaMenu, classOpeningMobileMenu, classOpeningMobileSearch);
            toggleRoleToPrimaryMenu();
            activateSearchInput();
            GT.disableDetectScrollUpOrDown = true;
            searchToggleBtn.setAttribute("aria-expanded", true);
        } else {
            closeAllMegaMenu();
            if (htmlElm.classList.contains(classOpeningMobileSearch)) {
                // Closing search
                toggleRoleToPrimaryMenu(false);
                htmlElm.classList.remove(classOpeningMegaMenu, classOpeningMobileMenu);
                setTimeout(() => {
                    htmlElm.classList.remove(classOpeningMobileSearch);
                }, 250);
                GT.disableDetectScrollUpOrDown = false;
            } else if (htmlElm.classList.contains(classOpeningMobileMenu)) {
                GT.SearchOverlayV3.triggerInitializeSearchOverlay();
                // Switching from menu to search
                toggleRoleToPrimaryMenu();
                htmlElm.classList.add(classOpeningMobileSearch);
                searchToggleBtn.setAttribute("aria-expanded", true);
                activateSearchInput();
            }
        }
    }

    function handleMenuToggle(menuToggleBtn, isOpening) {
        toggleRoleToPrimaryMenu(false);
        if (!isOpening) {
            // Opening menu
            htmlElm.classList.add(classOpeningMegaMenu, classOpeningMobileMenu);
            GT.disableDetectScrollUpOrDown = true;
            menuToggleBtn.setAttribute("aria-expanded", true);
            setTimeout(() => {
                primaryMenuFirstItem?.focus();
            }, 500);
        } else {
            if (htmlElm.classList.contains(classOpeningMobileSearch)) {
                // Switching from search to menu
                htmlElm.classList.add("closing");
                setTimeout(() => {
                    htmlElm.classList.remove("closing");
                    htmlElm.classList.remove(classOpeningMobileSearch);
                    GT.headerElm.querySelector(".global-search")?.classList.remove("open");
                }, 700);

                menuToggleBtn.setAttribute("aria-expanded", true);
                primaryMenuFirstItem?.focus();
            } else {
                // Closing menu
                htmlElm.classList.remove(classOpeningMegaMenu, classOpeningMobileMenu);
                closeAllMegaMenu();
                GT.disableDetectScrollUpOrDown = false;
            }
        }
    }

    function updateBleedHeight() {
        setTimeout(() => {
            const openingBleed = GT.headerElm.querySelector(".bleed.open");
            if(openingBleed) {
                GT.headerElm.style.setProperty("--bleed-height", openingBleed.querySelector(".bleed-container").offsetHeight + "px");
            }
        }, 300)
    }

    function closeAllMegaMenu() {
        GT.headerElm.querySelectorAll(".nav-link--dropdown.open, .bleed.open, .bleed .open").forEach(item => {
            if (item.classList.contains("nav-link--dropdown")) {
                item.setAttribute("aria-expanded", false);
            }
            item.classList.remove("open");
        });
        GT.headerElm.querySelectorAll(".bleed [tabindex='0']").forEach(item => {
            item.removeAttribute("tabindex");
            if(item.getAttribute('aria-expanded') == 'true'){
                item.setAttribute('aria-expanded', 'false');
            }
        });
    }

    function toggleMegaMenuLv2(e) {
        const target = e.target,
            parentElm = target.closest(".mega__level--2"),
            isOpening = parentElm.classList.contains("open");

        const oldActiveLv2 = GT.headerElm.querySelectorAll(".mega__level--2.open");
        oldActiveLv2.forEach(lv2 => {
            lv2.classList.remove("open");
        });
        
        setTimeout(() => {
            target.scrollIntoView({behavior: 'auto', block: 'nearest', inline: 'start'});
            oldActiveLv2.forEach(lv2 => {
                lv2.querySelector(".mega__level--3__listing")?.classList.remove("open");
            });
        }, 350);

        if(isOpening) { 
            target.setAttribute("aria-expanded", false); 
            updateBleedHeight(target); 
            return; 
        } else {
            target.setAttribute("aria-expanded", true);
        }

        parentElm.querySelectorAll(".mega__level--3__listing a").forEach(lv3Item => {
            lv3Item.removeAttribute("tabindex");
        })
        parentElm.classList.add("open");
        const lv3Height = parentElm.querySelector(".mega__content--listing").offsetHeight;
        parentElm.querySelector(".mega__level--3__listing")?.classList.add("open");
        parentElm.style.setProperty("--lv3-height", lv3Height + "px");
        updateBleedHeight(target);
        
        // GT.headerElm.querySelector(".header-menu-wrapper").scrollTo({top: (GT.getElementOffset(target).top) - 200, behavior: 'smooth'});
    }

    function initializedMegaMenuLv2() {
        const isDesktopView = GT.isDesktopView();
        GT.headerElm.querySelectorAll(".mega__level--2-group").forEach(item => {
            const aElm = item.querySelector("a");
            item.removeAttribute("role");
            item.removeAttribute("tabindex");
            if(aElm) {
                aElm.removeAttribute("tabindex");
                aElm.removeAttribute("aria-hidden");
                item.removeAttribute("aria-label");
                item.removeAttribute("aria-expanded");
            }
            
            if(!isDesktopView) {
                item.setAttribute("role", "button");
                if(aElm) {
                    aElm.setAttribute("tabindex", -1);
                    aElm.setAttribute("aria-hidden", "true");
                    item.setAttribute("aria-label", aElm.textContent.trim());
                    item.setAttribute("aria-expanded", false);
                }
            }

            if(!item.dataset.setEvent) {
                item.addEventListener("click", e => {
                    toggleMegaMenuLv2(e);
                })
                item.addEventListener("keydown", e => {
                    if(e.key === "Enter") {
                        toggleMegaMenuLv2(e);
                    }
                })
                item.dataset.setEvent = true;
            }
        })
    }

    GT.windowResizeFncList.mobileMenuV3 = () => {
        initializedMegaMenuLv2();
    };
};

GT.domContentLoadedFncList.push(function(){
    GT.MobileMenuV3();
});
GT.PrimaryMenuV3 = function () {
    if(typeof isNav3 == "undefined") return;

    const htmlElm = document.documentElement,
        submenuTimer = [];

    GT.triggerFnListAfterMainLogoLoaded.prepareSubMenuLink = prepareSubMenuLink;

    bindOutsideClick();
    initSearchBox();

    window.addEventListener("resize", e => {
        if(GT.isDesktopView() && htmlElm.classList.contains("opening-header-overlay")) 
            GT.Overlays.hideHeaderOverlay();
    })
    GT.windowResizeFncList.prepareSubMenuLink = function(){
        prepareSubMenuLink(true);
    }

    function initSearchBox() {
        let globalSearch = document.querySelector('.global-search');
        let searchButton = globalSearch?.querySelector('.header-search__icon');
        let closeButton = globalSearch?.querySelector('.header-search__close');

        if(GT.isIOS()) {
            searchButton?.addEventListener('touchstart', function(e) {
                let _this = this;
                // Close humberger menu when search box is openned
                let humbergerMenu = document.querySelector('.menu-toggle');
                if(humbergerMenu.classList.contains('open')) {
                    humbergerMenu.click();
                }

                setTimeout(function() {    
                    globalSearch.classList.toggle('search-open');
                    globalSearch.closest('.main-header').classList.toggle('search-open');
                    
                    if(globalSearch.classList.contains('search-open')) {
                        GT.Overlays.showHeaderOverlay();
                    } else {
                        GT.Overlays.hideHeaderOverlay();
                    }

                    _this.addEventListener('touchend', function(e) {
                        let searchField = globalSearch.querySelector('input[name="q"]');
                        if(globalSearch.classList.contains('search-open')) {
                            searchField.setAttribute('autofocus', 'autofocus');
                            searchField.focus();
                        } else {
                            searchField.blur();
                        }
                    });
                }, 100);
            });
        } else {
            searchButton?.addEventListener('click', function(e) {
                if(GT.isMobile() || GT.isMobileView()) {
                    // Close humberger menu when search box is openned
                    let humbergerMenu = document.querySelector('.menu-toggle');
                    if(humbergerMenu.classList.contains('open')) {
                        humbergerMenu.click();
                    }

                    setTimeout(function() {
                        globalSearch.classList.toggle('search-open');
                        globalSearch.closest('.main-header').classList.toggle('search-open');
                        if(globalSearch.classList.contains('search-open')) {
                            let searchField = globalSearch.querySelector('input[name="q"]');
                            searchField.setAttribute('autofocus', 'autofocus');
                            searchField.focus();
                            GT.Overlays.showHeaderOverlay();
                        } else
                            GT.Overlays.hideHeaderOverlay();
                    }, 100);
                }
            });
        }
        
        searchButton?.addEventListener('click', function(e) {
            if(GT.isLargeDesktopView() || (!GT.isMobileView() && (e.currentTarget || e.target)?.closest(".global-search.open")))
                document.querySelector(".header-search__form")?.submit();
        })

        closeButton?.addEventListener('click', function(e) {
            if(GT.isMobile() || GT.isMobileView()) {
                if(globalSearch.classList.contains('search-open')) {
                    globalSearch.classList.remove('search-open');
                    globalSearch.closest('.main-header').classList.remove('search-open');
                    GT.Overlays.hideHeaderOverlay();
                }
            }
        })
    }

    function prepareSubMenuLink(forceRecheck) {
        if(GT.isMobileView()) return;
        
        let menu = document.querySelector('.main-header'),
            menuItem = menu.querySelectorAll('.level-1 > li:not(.extra-menu):not(.hide-webex)');
        
        let hasExtraItems = false,
            visibleElms = [];
        
        menu.querySelectorAll('.extra-menu .menu-link').forEach(item => {
            item.remove();
        })

        if(htmlElm.classList.contains("opening-header-overlay")) 
            GT.Overlays.hideHeaderOverlay();

        GT.hideHyperLinkAnimation();
        
        menuItem.forEach(function(el){
            el.classList.remove('extra');
        })


        if(forceRecheck) {
            menu.querySelector('.extra-menu')?.remove();
        }

        GT.checkElmVisible('.level-1 > li:not(.extra-menu):not(.hide-webex)', {
            callback: (e) => {
                visibleElms.push(e);
                submenuTimer.forEach(timer => {
                    clearTimeout(timer);
                })
                submenuTimer.push(setTimeout(() => {
                    let visibleElmsLength = visibleElms.length;
                    hasExtraItems = false,
                    menuItem.forEach(function(el, index){
                        if (index >= visibleElmsLength) {
                            el.classList.add('extra');
                            hasExtraItems = true;
                        }
                    });
            
                    if (hasExtraItems) {
                        appendSubMenu();
                    }
                }, 50));
            }
        });

        function appendSubMenu() {
            GT.hideHyperLinkAnimation();
            let extraMenuItemsHtml = '';
            menu.querySelectorAll('li.extra').forEach(function(element){
                extraMenuItemsHtml += `<li>${element.innerHTML}</li>`;
            });

            const extraMenuHtml = `
                <div class="menu-link extra-menu">
                    <button class="button-nav__link nav-link" aria-expanded="false" aria-label="${menu.dataset.morelabel}">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 100 100">
                            <path d="M49.5,44.6c-2.9,0-5.3,2.4-5.3,5.3c0,2.9,2.4,5.3,5.3,5.3c2.9,0,5.3-2.4,5.3-5.3C54.8,47,52.4,44.6,49.5,44.6z"/>
                            <path d="M73.3,44.6c-2.9,0-5.3,2.4-5.3,5.3c0,2.9,2.4,5.3,5.3,5.3c2.9,0,5.3-2.4,5.3-5.3C78.6,47,76.2,44.6,73.3,44.6z"/>
                            <path d="M25.8,44.6c-2.9,0-5.4,2.4-5.4,5.3c0,2.9,2.4,5.3,5.4,5.3c2.9,0,5.4-2.4,5.4-5.3C31.1,47,28.7,44.6,25.8,44.6z"/>
                        </svg>
                    </button>
                    <div class="bs-hider"></div>
                    <ul class="sub-menu">${extraMenuItemsHtml}</ul>
                </div>`;

            menu.querySelector('.primary-menu').insertAdjacentHTML("beforeend", extraMenuHtml);
            const extraMenu = menu.querySelector('.extra-menu');

            document.querySelector('ul.list--mega.level-1 .menu-link')?.addEventListener('click', function(e) {
                if(htmlElm.classList.contains("global-reach--opening")) return;

                GT.MegaMenuV3.closeSecondary();

                let cursorElm = this.querySelector(".button-nav__link");
                let focusableElms = [extraMenu.querySelector('.button-nav__link'), ...extraMenu.querySelectorAll('.sub-menu a, .sub-menu button')];
                if (this.classList.contains('open')) {
                    if (e.target && !e.target.classList.contains('sub-menu')) {
                        this.classList.remove('open');
                        cursorElm?.setAttribute("aria-expanded", false);
                        GT.Overlays.hideHeaderOverlay();
                        GT.unloopFocus(focusableElms);
                        document.documentElement.classList.remove('show-extra-menu');
                    }
                } else {
                    GT.hideHyperLinkAnimation();
                    this.classList.add('open');
                    cursorElm?.setAttribute("aria-expanded", true);
                    GT.Overlays.showHeaderOverlay();
                    document.documentElement.classList.add('show-extra-menu');
                    GT.loopFocus(this.querySelector(".sub-menu"), focusableElms);
                }
            });
        }
    }

    function bindOutsideClick() {
        document.addEventListener('click', (e) => {
            const onPageNav = document.querySelector('.onpage-navigation');
            if (e.target && !e.target.closest('.onpage-navigation')) {
                if (!e.target.closest('.nav3') && !htmlElm.classList.contains("global-reach--opening")) {
                    document.querySelectorAll('ul.list--mega.level-1 .menu-link').forEach(link => link.classList.remove('open'));
        
                    // Hide header overlay if click on header, except search input
                    if (
                        e.target.id !== 'searchField' &&
                        !document.querySelector('.global-search.search-open')
                    ) {
                        GT.Overlays.hideHeaderOverlay();
                    }
                    if (onPageNav?.classList.contains('expanded')) {
                        GT.OnPageNavigation?.closeOnPageNav();
                    }
                }
            }
        });        
    }
};

GT.domContentLoadedFncList.push(function(){
    GT.PrimaryMenuV3();
});
GT.Reach = function() {
    let isInited = false,
        htmlElm = document.firstElementChild,
        globalReachElm = document.querySelector(".global-reach");

    if (!globalReachElm) return;

    let globalReachToggleBtn = GT.headerElm.querySelector(".global-reach__toggle"),
        globalReachCloseBtn = globalReachElm.querySelector(".global-reach__close"),
        desktopGlobalSiteCta = document.querySelector('.global-site-cta--desktop'),
        globalReachTabElms,
        animationTime = 600,
        isDesktop = GT.isDesktopView();

        
    if(typeof isNav3 == "undefined") {
        globalReachToggleBtn = GT.isMobileView() ? GT.headerElm.querySelector(".global-toggle-m") : GT.headerElm.querySelector(".global-reach__toggle");
    }

    function disableScroll(isDisable){
        if(isDesktop) {
            if(isDisable) {
                typeof isNav3 != "undefined" && GT.Overlays.showHeaderOverlay();
                GT.headerElm.querySelector(".menu-link.open")?.classList.remove("open");
            } else {
                GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
                GT.headerElm.style.setProperty("--globalreach-height", 0);
                globalReachElm.classList.remove("trigger-animation");
                typeof isNav3 != "undefined" && GT.Overlays.hideHeaderOverlay();
            }
        }

        document.documentElement.classList.remove('show-extra-menu');
        
        if(isDisable) {
            htmlElm.classList.add("global-reach--opening");
            if (htmlElm.classList.contains("lang-dropdown--opening")) {
                htmlElm.querySelector('.header-lang__select')?.click();
            }
        } else {
            htmlElm.classList.remove("global-reach--opening");
            setTimeout(e => {
                globalReachToggleBtn?.focus();
            }, 1000)
        }
    }

    function calcActivatedTabHeight() {
        GT.headerElm.style.setProperty("--globalreach-height", (globalReachElm.querySelector(".global-reach__list.active ul")?.offsetHeight || 0) + "px");
        globalReachElm.classList.add("open");
        setTimeout(() => {
            globalReachElm.classList.add("trigger-animation");
        }, isDesktop ? animationTime : 0);
    }

    function initReachToggle() {
        if(globalReachToggleBtn.dataset.inited)
            return;

        globalReachToggleBtn.dataset.inited = true;

        function pressESCToClose(e){
            if(e.key == "Escape") {
                globalReachToggleBtn.click();
            }
        }

        function handleElementRole() {
            if(GT.isMobileCached) {
                globalReachElm.querySelector(".global-reach__tabs").setAttribute("role", "navigation");
                globalReachElm.querySelector(".reach-region-selector").removeAttribute("role");
            }
            globalReachTabElms.forEach(tabItem => {
                const parentTab = tabItem.closest("ul");
                if(GT.isMobileCached) {
                    tabItem.setAttribute("tabindex", 0);
                    tabItem.setAttribute("aria-expanded", false);
                    tabItem.removeAttribute("role");
                    parentTab.removeAttribute("role");
                    parentTab.querySelector(".global-reach__list").removeAttribute("role");
                } else {
                    tabItem.setAttribute("role", "tab");
                    tabItem.setAttribute("aria-selected", false);
                    tabItem.removeAttribute("aria-expanded");
                    tabItem.setAttribute("tabindex", -1);
                    parentTab.setAttribute("role", "tablist");
                    parentTab.querySelector(".global-reach__list").setAttribute("role", "tabpanel");

                    if(tabItem.classList.contains("active")) {
                        tabItem.setAttribute("tabindex", 0);
                        tabItem.setAttribute("aria-selected", true);
                        setTimeout(() => {
                            TabPanelActionHandler(tabItem.closest("ul"));
                        }, 500);
                    }
                }
            })
        }

        desktopGlobalSiteCta?.addEventListener('keydown', keyPressHandle);

        GT.headerElm.querySelectorAll('.header-menu-mobile .nav-toggle, .global-reach .nav-level-toggle').forEach(btn => {
            btn.addEventListener('click', () => {
                if (globalReachElm.classList.contains("open")) {
                    setTimeout(() => {
                        globalReachElm.querySelectorAll('.reach-region-selector button.active, .reach-region-selector .global-reach__list.active').forEach(item => item.classList.remove('active'));
                    }, animationTime);
                }
            })
        })

        GT.headerElm.querySelector(".main-header").addEventListener("click", (e) => {
            if(e.target.closest(".global-reach--opening") && !e.target.closest(".global-reach") && !e.target.closest(".header-utils-wrap"))
                globalReachToggleBtn.click();
        });
        
        globalReachToggleBtn.addEventListener('click', function(e) {
            e.preventDefault();
            // if ($(e.target).hasClass('lang-dropdown-arrow')) {
            //     e.stopPropagation();
            //     return;
            // }
            
            if(isDesktop) {
                GT.headerElm.querySelector(".header-group-btn.open")?.click();
            }

            if (globalReachElm.classList.contains("open")) {
                document.querySelectorAll('.header-logo, .header-menu-mobile').forEach(item => {
                    item.removeAttribute("aria-hidden");
                })
                globalReachElm.classList.remove("open");
                globalReachToggleBtn.setAttribute("aria-expanded", false);
                globalReachElm.setAttribute("aria-hidden", true);
                disableScroll();
                window.removeEventListener("keydown", pressESCToClose);
            } else {
                window.addEventListener("keydown", pressESCToClose);
                globalReachElm.removeAttribute("aria-hidden");
                globalReachToggleBtn.setAttribute("aria-expanded", true);
                document.querySelectorAll('.header-logo, .header-menu-mobile').forEach(item => {
                    item.setAttribute("aria-hidden", true);
                })

                if(!isInited) {
                    GT.headerElm.classList.add("fetching");
                    isInited = true;
                    
                    globalReachElm.querySelectorAll('.global-reach__close, .nav-level-toggle').forEach(closeElm => {
                        closeElm.addEventListener("click", () => {
                            if (htmlElm.classList.contains("lang-dropdown--opening")) {
                                htmlElm.classList.remove("lang-dropdown--opening");
                            }
                            document.querySelectorAll('.header-logo, .header-menu-mobile').forEach(item => {
                                item.removeAttribute("aria-hidden");
                            })
                            globalReachElm.classList.remove("open");
                            globalReachElm.setAttribute("aria-hidden", true);
                            globalReachToggleBtn.setAttribute("aria-expanded", false);
                            disableScroll();
                        })
                    });


                    httpService = new HttpService();
                    httpService.getHtmlContent(globalReachLink, null, {"Content-type": "application/x-www-form-urlencoded"}, true).then(response => {

                        let globalReachRegionsMoileLV1Elm = document.querySelector(".mobile__global--level-1 .list");
                        if(globalReachRegionsMoileLV1Elm)
                            globalReachRegionsMoileLV1Elm.classList.remove("hide");

                        globalReachElm.querySelector("#global-reach-regions").insertAdjacentHTML("beforeend", `
                            <div class="global-reach__content">
                                ${response}
                            </div>
                        `);
                        GT.hideHyperLinkAnimation();
                        calcActivatedTabHeight();
                        setTimeout(function() {
                            globalReachTabElms = document.querySelectorAll('.reach-region-selector li button');
                            
                            globalReachTabElms.forEach(tabItem => {
                                tabItem.addEventListener("click", keyPressHandle);
                                tabItem.addEventListener("keydown", keyPressHandle);
                            })

                            if(isDesktop)
                                globalReachTabElms[0].click();
                            
                            handleElementRole();
                            GT.GTMGlobal.megaMenu();
                        }, 100);
                    })
                    .catch((rej) => {
                        isInited = false;
                    })
                    .finally(() => {
                        GT.headerElm.classList.remove("fetching");
                    });

                } else {
                    calcActivatedTabHeight();
                    handleElementRole();
                }

                disableScroll(true);
                setTimeout(function() {
                    globalReachCloseBtn?.focus();
                    linkHandle();
                }, 1000);
            }
        });

    }

    function keyPressHandle(e) {
        if (e.key != "Tab") {
            e.preventDefault();
        }

        if (e.key == "Tab") {
            if (isDesktop) {
                const target = e.target;
                const activeLinks = globalReachElm.querySelectorAll('.global-reach__list.active .local-site-link');
                const firstActiveLink = activeLinks[0];
                const lastActiveLink = activeLinks[activeLinks.length - 1];

                if (e.shiftKey) {
                    if (target.closest('.global-site-cta--desktop')) {
                        e.preventDefault();
                        lastActiveLink && lastActiveLink.focus();
                    }
                } else {
                    if (target.getAttribute('aria-selected') == "false") {
                        e.preventDefault();
                        firstActiveLink && firstActiveLink.focus();
                    } else if (target.closest('.global-site-cta--desktop')) {
                        e.preventDefault();
                        globalReachCloseBtn?.focus();
                    }
                }
            }
        }

        if (!e.keyCode || e.key == "Enter" || e.key == " ") {
            GT.hideHyperLinkAnimation();
            const currentTab = e.target,
                activeEl = currentTab.dataset.tab;

            if (!currentTab.classList.contains("active")) {
                globalReachTabElms.forEach(tabItem => {
                    tabItem.setAttribute("aria-selected", false);
                })

                if(!GT.isMobileCached) {
                    globalReachTabElms.forEach(tabItem => {
                        tabItem.removeAttribute("aria-expanded");
                        tabItem.setAttribute("tabindex", -1);
                    })
                    currentTab.setAttribute("tabindex", 0);
                    currentTab.setAttribute("aria-selected", true);
                } else {
                    globalReachTabElms.forEach(tabItem => {
                        tabItem.setAttribute("aria-expanded", false);
                    })
                    currentTab.setAttribute("aria-expanded", true);
                }

                globalReachTabElms.forEach(tabItem => {
                    tabItem.classList.remove("active");
                })
                currentTab.classList.add("active");

                document.querySelectorAll(".global-reach .global-reach__list").forEach(listPanelItem => {
                    listPanelItem.classList.remove("active");
                    listPanelItem.querySelectorAll('a')?.forEach(item => {
                        item.setAttribute('tabindex', -1);
                    })
                    
                    if (listPanelItem.classList.contains(activeEl)) {
                        listPanelItem.classList.add("active");
                        listPanelItem.querySelectorAll('a')?.forEach(item => {
                            item.setAttribute('tabindex', 0);
                        })
                        calcActivatedTabHeight();
                    }
                })

                if(!isDesktop)
                    setTimeout(() => {
                        currentTab.scrollIntoView({behavior: 'auto', block: 'nearest', inline: 'start'});
                    }, 400);
            } else {
                if(!isDesktop) {
                    currentTab.classList.remove("active");
                    document.querySelector(".global-reach .global-reach__list.active")?.classList.remove("active");
                    GT.headerElm.style.setProperty("--globalreach-height", 0);
                    currentTab.setAttribute("aria-expanded", false);
                }
            }
        }
    }

    function linkHandle() {
        document.querySelectorAll('.global-reach__list a').forEach(item => {
            let parentElm = item.closest('li');
            item.addEventListener('keydown', function(e) {
                if (e.key == 'Tab' && !e.shiftKey && !parentElm.nextElementSibling && isDesktop) {
                    e.preventDefault();
                    let globalSiteCta = document.querySelector('.global-site-cta--desktop');
                    if(globalSiteCta)
                        globalSiteCta.focus();
                    else
                        globalReachCloseBtn?.focus();
                }
            });
        });
    }

    initReachToggle();
    
    GT.windowResizeFncList.globalReach = function(){
        isDesktop = GT.isDesktopView();
        if(htmlElm.classList.contains("global-reach--opening"))
            globalReachToggleBtn.click();

        if(typeof isNav3 == "undefined") {
            globalReachToggleBtn = GT.isMobileView() ? GT.headerElm.querySelector(".global-toggle-m") : GT.headerElm.querySelector(".global-reach__toggle");
        }
    }
};

GT.domContentLoadedFncList.push(function(){
    GT.Reach();
})
GT.SearchOverlayV3 = function() {
    let htmlElm = document.firstElementChild;
    let searchWrapper = document.querySelector('.btn-search');
    let searchButtonToggle = searchWrapper?.querySelector('.global-search__toggle');
    let globalSearch = document.querySelector('.global-search');

    if (!globalSearch) return;

    let searchForm = globalSearch.querySelector('.header-search__form');
    let searchOverlayModal = globalSearch.querySelector('.search-overlay__modal');
    let searchboxInput = searchForm.querySelector('input[name="q"]');
    let searchButton = globalSearch.querySelector('.header-search__icon');
    let submitButton = globalSearch.querySelector('form.header-search__form input[name="search-submit__button"]');
    let popularSearchResults = null;
    let prevSuggestionResults = null;
    let searchResultsContainer = globalSearch.querySelector('.search-overlay__contents');
    let disabledSearchOverlayAtrr = searchboxInput.getAttribute('disabled-searchoverlay');
    let disabledPopularSearchAtrr = searchboxInput.getAttribute('disabled-popularsearch');
    let disabledPreviousSearchAtrr = searchboxInput.getAttribute('disable-previoussearch');
    let userPreviousSearchesDataAtrr = null;
    let oldSearchKeyword = "";
    let isInitialized = false;
    const bleedWrapperElm = document.querySelector('.global-search-area .bleed-wrapper');

    const INPUT_START_TYPING_LENGTH = 3;
    const MAX_PREVIOUS_SEARCH_ITEMS = 6;
    let httpService = new HttpService();

    init();

    function processPreviousSearch() {

        if(isDisabledPreviousSearch()) return;

        let searchPageUrl = searchForm.getAttribute('action');
        let previousSearchTitle = searchOverlayModal.getAttribute('previous-search-title');
        let userPreviousSearches = JSON.parse(localStorage.getItem('user_previous_searches'));
        // Show previous search section
        if(userPreviousSearches != null && userPreviousSearches.length > 0) {
            userPreviousSearchesDataAtrr = userPreviousSearches;
            let previousSearchHtml = '<div class="popular-search__container">';
            previousSearchHtml     += '    <div class="gt-small-title heavy search-panel__title">' + previousSearchTitle +'</div>';
            previousSearchHtml     += '    <div class="search-panel__details">';
            previousSearchHtml     += '        <ul class="search-suggestion__list">';
            
            [].forEach.call(userPreviousSearches, function(_keyword) {
                previousSearchHtml += '<li><a href="' + searchPageUrl + '?q=' + encodeURIComponent(_keyword) + '" title="' + _keyword + '">' + _keyword.replace(/(<([^>]+)>)/gi, "") + '</a></li>';
            });

            previousSearchHtml     += '        </ul>';
            previousSearchHtml     += '    </div>';
            previousSearchHtml     += '</div>';
            
            let previousSearchesSection = document.getElementById('previous-search__container');
            if(previousSearchesSection != null) {
                previousSearchesSection.remove();
            }

            let wrapPreviousSearchesHtml = document.createElement('div');
            wrapPreviousSearchesHtml.id = 'previous-search__container';
            wrapPreviousSearchesHtml.className = 'search-contents__container';

            wrapPreviousSearchesHtml.innerHTML = previousSearchHtml;
            searchResultsContainer.insertBefore(wrapPreviousSearchesHtml, searchResultsContainer.firstChild);
        }
    }

    function triggerInitializeSearchOverlay() {
        openGlobalSearch();

        toggleSearchModal(false);
        
        // Process to display user's previous searches

        if(!isInitialized) {
            processPreviousSearch();

            // Show modal in case second time user focus to search box when input length > 3
            let _searchKeyword = this.value?.trim() || "";
            if(_searchKeyword.length >= INPUT_START_TYPING_LENGTH) {
                // Send ajax request if only input new keyword 
                if(_searchKeyword != oldSearchKeyword.trim()) {
                    oldSearchKeyword = _searchKeyword;
                    getSuggestionSearch(encodeURIComponent(_searchKeyword));
                } else {
                    if(prevSuggestionResults) {
                        searchResultsContainer.innerHTML = prevSuggestionResults;
                    }
                    openGlobalSearch();
                    toggleSearchModal(true);
                }
            } else {
                if((popularSearchResults != null && popularSearchResults.length > 0)
                    || (userPreviousSearchesDataAtrr != null && userPreviousSearchesDataAtrr.length > 0)
                ) {
                    toggleSearchModal(true);
                }
            }
            isInitialized = true;
        }

        if(isDisabledPopularSearch()) {
            // Hide search overlay modal in case input length < 3
            if((searchboxInput.value.length < INPUT_START_TYPING_LENGTH) 
                && (userPreviousSearchesDataAtrr == null || userPreviousSearchesDataAtrr.length <= 0)) {

                toggleSearchModal(false);
            }

            return;
        }

        // Show popular search on modal when first time user focus to search box
        if(popularSearchResults == null || popularSearchResults.length <= 0) {
            getPopularSearch();
        }
        searchResultsContainer.classList.add('show');
        toggleLoading(false);
        GT.headerElm.style.setProperty('--bleed-height', bleedWrapperElm.offsetHeight + 'px');
    }

    function initSearchOverlay() {
        searchboxInput.addEventListener('click', function() {
            triggerInitializeSearchOverlay();
        });

    };

    function isDisabledPreviousSearch() {
        return (!disabledPreviousSearchAtrr || disabledPreviousSearchAtrr.toLowerCase() == 'true');
    }

    function isDisabledPopularSearch() {
        return (!disabledPopularSearchAtrr || disabledPopularSearchAtrr.toLowerCase() == 'true');
    }

    function openGlobalSearch() {
        if(document.querySelector('.global-reach.open')) return;

        if(!globalSearch.classList.contains('open')) {
            globalSearch.querySelectorAll('input, a, button').forEach(item => {
                item.removeAttribute('tabindex');
            })
            globalSearch.classList.add('open');
        }

        if (GT.isDesktopView())
            htmlElm.classList.add("global-search--opening");
    }

    function toggleSearchModal(_isShow) {
        if(_isShow) {
            setTimeout(e => {
                GT.GTMGlobal.globalSearch();
            }, 100);
        }
    }

    function toggleLoading(enable) {
        const header = document.querySelector('.header');
        if (enable) {
            header.classList.add('fetching');
        } else
            header.classList.remove('fetching');
    }

    function escapeQueryChars(url) {
        return url
            .replace(/\s/gi, '+')
            .replace(/\%20/gi, '+')
            .replace(/\%(3C|3E)/gi, function (match, dec) {
                return encodeURI('%') + dec;
            });
    }

    function getPopularSearch() {
        let popularSearchEndpoint = searchboxInput.getAttribute('data-endpoint-popularsearch');
        if(popularSearchEndpoint == null || popularSearchEndpoint.length <= 0) return;
        popularSearchEndpoint = escapeQueryChars(popularSearchEndpoint);

        let recentIds = GT.Cookies.getCookie("recentIds");
        popularSearchEndpoint += "&recentIds=" + recentIds;
        
        httpService.getHtmlContent(popularSearchEndpoint, null, { "Content-type": "application/x-www-form-urlencoded" }, true).then(data => {
            if (data.trim() == null || data.trim().length <= 0) {
                if (!userPreviousSearchesDataAtrr) {
                    toggleSearchModal(false);
                } else {
                    toggleSearchModal(true);
                }
            } else {
                popularSearchResults = data;
                searchResultsContainer.innerHTML = data;
                processPreviousSearch();
                linkKeyPressHandle();
                toggleSearchModal(true);
            }

            
        })
            .catch((rej) => {
                console.log(rej)
            })
            .finally(() => {
                GT.headerElm.style.setProperty('--bleed-height', bleedWrapperElm.offsetHeight + 'px');
            });

    }

    function getSuggestionSearch(_searchTerm) {
        let suggestionSearchEndpoint = searchboxInput.getAttribute('data-endpoint-searchsuggestion');

        if(suggestionSearchEndpoint == null || suggestionSearchEndpoint.length <= 0) return;

        suggestionSearchEndpoint = suggestionSearchEndpoint + _searchTerm;

        suggestionSearchEndpoint = escapeQueryChars(suggestionSearchEndpoint);
        
        httpService.getHtmlContent(suggestionSearchEndpoint, null, { "Content-type": "application/x-www-form-urlencoded" }, true).then(data => {
                if(data.trim() == null || data.trim().length <= 0) {
                    toggleSearchModal(false);
                } else {
                    prevSuggestionResults = data;
                    searchResultsContainer.innerHTML = data;
                    openGlobalSearch();
                    linkKeyPressHandle();
                    toggleSearchModal(true);
                }
            })
            .catch((rej) => {
                console.log(rej)
            })
            .finally(() => {
                GT.headerElm.style.setProperty('--bleed-height', bleedWrapperElm.offsetHeight + 'px');
                toggleLoading(false);
            });
    }

    function linkKeyPressHandle() {
        const CONTAINER_SELECTORS = [
            '.recently-visited__container',
            '.search-contents__container.popular-search__container',
            '.results-search__container.has-search__results',
            '.popular-search__container.results-search__container'
        ];
        
        const searchOverlayLinks = document.querySelectorAll('.search-suggestion__list a, .search-results__list a');

        searchOverlayLinks.forEach(item => {
            // Only process last links in their list
            if (item.closest('li').nextElementSibling) return;

            // Find the parent container
            let parentContainer = item.closest('#previous-search__container');
            if (!parentContainer) {
                parentContainer = CONTAINER_SELECTORS
                    .map(selector => item.closest(selector))
                    .find(element => element !== null);
            }

            // Add tab handler for last link in last container
            if (parentContainer && !parentContainer.nextElementSibling) {
                item.addEventListener('keydown', (e) => {
                    if ((e.key === 'Tab' || e.keyCode === 9) && !e.shiftKey && GT.isDesktopView()) {
                        e.preventDefault();
                        searchButtonToggle?.focus();
                    }
                });
            }
        });
    }

    function init() {
        if(!disabledSearchOverlayAtrr || disabledSearchOverlayAtrr.toLowerCase() == 'true') {
            return;
        }

        initSearchOverlay();

        globalSearch.addEventListener("keydown", (e) => {
            const { key, target } = e;

            if (key === "Tab" && GT.isDesktopView()) {
                if (target === searchboxInput || target === searchButton) {
                    e.preventDefault();
                    
                    if (target === searchboxInput) {
                        e.shiftKey ? searchButtonToggle?.focus() : searchButton.focus();
                    } else {
                        if (e.shiftKey) {
                            searchboxInput.focus();
                        } else {
                            const firstLink = globalSearch.querySelector('.search-overlay__contents a');
                            (firstLink || searchButtonToggle)?.focus();
                        }
                    }
                }
            }

            if (key === "Escape" && document.querySelector('.global-search.open')) {
                GT.isScreenReader = true;
                closeAction();
            }
        });

        searchboxInput.addEventListener('input', GT.debounce(function(){
            searchboxOnChange();
        }, 500));

        searchButton.addEventListener('click', function(e) {
            if(searchboxInput.value.length <= 0) {
                searchboxInput.focus();
                return;
            }
            submitButton.click();
        });



        function handleFirstFocusableElm() {
            let _firstFocusable = GT.getFirstFocusableVisible();

            if(!_firstFocusable.dataset.initialized)
                _firstFocusable.addEventListener('keydown', function(e) {
                    let _keycode = e.keyCode || e.which;
                    if (9 == _keycode && e.shiftKey) {
                        e.preventDefault();
                        document.querySelector('#searchField').focus();
                    }
                });

            _firstFocusable.dataset.initialized = true;
            // #175120 - Remove focusing on first element when user close the Global search when scrolling the page
            if(window.scrollY < 10)
                setTimeout(function() {
                    _firstFocusable.focus();
                },500);
        }

        function closeAction(){
            closeSearchOverlay();
            // handleFirstFocusableElm();
        }


        searchForm.addEventListener('submit', e => {

            if(isDisabledPreviousSearch()) return;

            let searchkeyword = searchboxInput.value;
            
            if(searchkeyword == null || searchkeyword.trim().length <= 0) {
                return false;
            }
                            
            //Process to save search keyword into local stograde before submit search form
            GT.processSearchKeywordBeforeSubmit(searchkeyword.trim(), userPreviousSearchesDataAtrr, MAX_PREVIOUS_SEARCH_ITEMS);
            dataLayer.push({ 'event': 'global_search', 'eventAction': 'navigation_search', 'eventLabel': searchkeyword });
        });
    }

    function searchboxOnChange(){
        let inputValue = searchboxInput.value.trim();
        if(inputValue.length >= INPUT_START_TYPING_LENGTH) {
            toggleLoading(true);
            getSuggestionSearch(encodeURIComponent(inputValue));
            oldSearchKeyword = inputValue;
        } else {
            if((isDisabledPopularSearch() || popularSearchResults == null) && (userPreviousSearchesDataAtrr == null || userPreviousSearchesDataAtrr.length <= 0)) {
                toggleSearchModal(false);
            } else {
                searchResultsContainer.innerHTML = popularSearchResults;
                
                // Add previous search section
                processPreviousSearch();
                GT.headerElm.style.setProperty('--bleed-height', bleedWrapperElm.offsetHeight + 'px');
                toggleSearchModal(true);
            }
        }
    }

    function closeSearchOverlay() {
        globalSearch.classList.remove('open');
        globalSearch.querySelectorAll('input, a, button').forEach(item => {
            item.setAttribute('tabindex', -1);
        })

        if (GT.isDesktopView()) {
            GT.MegaMenuV3.closeSecondary();
            setTimeout(() => {
                searchButtonToggle.focus();
            });
        }
    }

    return {
        triggerInitializeSearchOverlay
    }
};

GT.domContentLoadedFncList.push(function(){
    GT.SearchOverlayV3 = GT.SearchOverlayV3();
});

GT.TopBannerMessageForNoStickyHeader = function($elem) {
    var isStickyDisabled = !$('header').data('sticky');
    var header = $elem[0];

    $(document).ready(function() {
        if (isStickyDisabled) {
            window.onscroll = function() { handleTopBannderMessageOnMobile(); };
            window.onwheel = function() { handleTopBannderMessageOnMobile(); };
            window.onresize = function() { handleTopBannderMessageOnMobile(); };
            handleTopBannderMessageOnMobile();
        }
    });
    function isMessageTopBannerExist() {
        return $(header).find('.header-message-top-banner-wrapper').length;
    }
    function handleTopBannderMessageOnMobile() {
        if(isMessageTopBannerExist()) {
            if($(window).width() < 961){
                // if (window.pageYOffset > 0) {
                //     // $(header).find('.header-top').css('top', '0');
                //     $('.mobile').css('top', '63px');
                //     // $(header).find('.header-message-top-banner-wrapper').addClass('hidden-message');
                //     //recalculate header's height
                //     // if($(header).hasClass('campaign-header')) {
                //     //     $(header).css('height', '');
                //     // } else if ($(header).hasClass('main-header')){
                //     //     $(header).css('height', '64px');
                //     // }
                // } else if ($('html').css('position') != 'fixed') {
                //     var topBannerMessageHeight = $(header).find('.header-message-top-banner-wrapper').height();
                //     // $(header).find('.header-top').css('top', topBannerMessageHeight +'px');
                //     $('.mobile').css('top', topBannerMessageHeight+63 +'px');
                //     // $(header).find('.header-message-top-banner-wrapper').removeClass('hidden-message');
                //     //recalculate header's height
                //     // if($(header).hasClass('campaign-header')) {
                //     //     $(header).css('height', (topBannerMessageHeight) + 'px');
                //     // } else if ($(header).hasClass('main-header')){
                //     //     $(header).css('height', (topBannerMessageHeight+64) + 'px');
                //     // }
                // }
            } else {
                // reset when resize to desktop 
                // $(header).find('.header-message-top-banner-wrapper').removeClass('hidden-message');
                // $(header).find('.header-top').css('top', '0');
                // $(header).css('height', '');
                $('.insight-page').find('.breadcrumbs').css('padding-top', '30px');                
            }
        }
    }
}


GT.UtilityNavigation = function (elem) {
    let me = this;
    let htmlElm = document.firstElementChild;
    
    me.init = function () {

        let langCloseBtn = document.querySelector('.header-lang__close');
        // Create a class to handle each language dropdown instance
        class LangDropdown {
            constructor(headerLangElement) {
                this.element = headerLangElement;
                this.btnToggle = headerLangElement.querySelector('.header-lang__select');
                this.items = headerLangElement.querySelectorAll('.header-lang__dropdown a');
                this.itemsLength = this.items.length;
                this.init();
            }

            pressESCToClose = (e) => {
                if(e.key == "Escape") {
                    this.btnToggle.focus();
                    this.btnToggle.click();
                }

                if(e.key == "Tab" && e.shiftKey && (e.target || e.currentTarget).classList.contains("header-lang__select")) {
                    if(this.itemsLength) {
                        e.preventDefault();
                        this.items[this.itemsLength - 1].focus();
                    }
                }
            }

            doToggle = () => {
                if (!this.element.classList.contains('open') && !this.element.closest('.global-reach') && htmlElm.classList.contains('global-reach--opening')) {
                    typeof isNav3 != "undefined" && htmlElm.querySelector('.global-reach__toggle')?.click(); 
                }
                
                // Close other open dropdowns before opening this one
                document.querySelectorAll('.header-lang.open').forEach(openDropdown => {
                    if (openDropdown !== this.element) {
                        openDropdown.classList.remove('open');
                        openDropdown.querySelector('.header-lang__select')?.setAttribute('aria-expanded', 'false');
                    }
                });

                this.element.classList.toggle('open');
                typeof isNav3 != "undefined" && htmlElm.classList.toggle('lang-dropdown--opening');

                setTimeout(() => {
                    this.btnToggle?.focus();
                }, 1000);
                
                if (this.element.classList.contains('open')) {
                    GT.hideHyperLinkAnimation();
                    this.btnToggle.setAttribute('aria-expanded', 'true');
                    if (this.element.classList.contains('header-util-item')) {
                        setTimeout(() => {
                            langCloseBtn?.focus();
                        }, 1000);
                    }
                    document.querySelectorAll('.header-logo, .header-menu-mobile').forEach(item => {
                        item.setAttribute("aria-hidden", true);
                    })
                    window.addEventListener("keydown", this.pressESCToClose);
                } else {
                    this.btnToggle.setAttribute('aria-expanded', 'false');
                    document.querySelectorAll('.header-logo, .header-menu-mobile').forEach(item => {
                        item.removeAttribute("aria-hidden");
                    })
                    window.removeEventListener("keydown", this.pressESCToClose);
                }
            }

            init() {
                if (this.btnToggle) {
                    let closeBtn = htmlElm.querySelector('.header-lang__mobile-panel .header-lang__close');
                    this.btnToggle.addEventListener('click', () => this.doToggle());

                    if (this.itemsLength) {
                        this.items[this.itemsLength - 1].addEventListener("keydown", e => {
                            if (e.key == "Tab" && !e.shiftKey) {
                                e.preventDefault();
                                this.btnToggle.focus();
                            }
                        });
                    }

                    if (this.element.classList.contains('header-util-item')) {
                        closeBtn?.addEventListener('click', () => {
                            this.doToggle();
                        });
                    }
                }
            }
        }

        // Initialize all language dropdowns
        document.querySelectorAll('.header-lang').forEach(headerLangElement => {
            new LangDropdown(headerLangElement);
        });

        // langCloseBtn?.addEventListener('click', () => {
        //     htmlElm.classList.remove("lang-dropdown--opening");
        //     setTimeout(() => {
        //         htmlElm.querySelector('.header-utils .header-lang__select')?.focus();
        //     }, 100);
        // });
    }
    me.init();
};
GT.isNav2 = true;

GT.Initiator = function (__object) {
    // if test passed (selector present on site) - fire function form current object on obj context (passing as argument selector and arguments or empty)
    var __$tmp = __object.settings && __object.settings.nojquery ? document.querySelectorAll(__object.test) : $(__object.test);
    try {
        if (__$tmp.length && __object.constr)
            new __object.constr(__$tmp, __object);
    } catch (exp) {
        console.warn(exp);
    }
};

GT.domContentLoadedFncList.push(function(){

    GT.Cookies = new GTCookies();
    GT.Cookies.cookieNotify();

    GT.GTObjects = [
        { constr: GT.StickyHeaderV2, test: '.main-header', settings: { }},
        { constr: GT.PrimaryNavV2, test: '.header-menu', settings: { } },
        { constr: GT.FakeHyperlink, test: '[data-anchor]' },
        { constr: GT.SearchOverlayV2, test: '.global-search' },
        { constr: GT.MegaNavigationV2, test: '.mega-wrapper', settings: { } },
        { constr: GT.MobileNavigationV2, test: '.menu-toggle', settings: { } },
        { constr: GT.UtilityNavigation, test: '.header-utils', settings: { } }
    ];

    if(typeof isV1GT == "undefined") 
        GT.GTObjects.push({ constr: GT.Reach, test: '.global-reach' });

    GT.GTObjects.map(GT.Initiator);
});
GT.freezeVp = function (e) {
    e.preventDefault();
};


window.addEventListener("DOMContentLoaded", function(){
    GT.headerElm = document.querySelector("header");
    if(GT.headerElm) {
        GT.topBannerMsgElm = document.querySelector(".header-message-top-banner-wrapper");
        GT.countryPreselectionElm = document.querySelector(".country-preselection");
    }
    
    GT.mainHeaderElm = document.querySelector(".main-header");

    requestAnimationFrame(() => {
        GT.wHeight = window.innerHeight;
        GT.wWidth = window.innerWidth;
        GT.bodyWidth = document.body.clientWidth;
        GT.scrollbarWidth = GT.wWidth - GT.bodyWidth;
    });


    function triggerFunctionsAfterMainLogoLoaded(){
        setTimeout(function() {
            Object.keys(GT.triggerFnListAfterMainLogoLoaded).forEach(function(k) {
                GT.triggerFnListAfterMainLogoLoaded[k]();
            })
            setTimeout(function(){
                if(GT.headerElm) {
                    requestAnimationFrame(() => {
                        GT.headerElmHeight = GT.headerElm.clientHeight;
                    });

                    requestAnimationFrame(() => {
                        document.documentElement.style.setProperty('--header-height', GT.headerElmHeight + 'px');
                    });
                    

                    // Single rAF for both read and write since these are static elements
                    requestAnimationFrame(() => {
                        // Read phase - all measurements at once
                        const bannerHeight = (GT.topBannerMsgElm?.clientHeight || 0) + (GT.countryPreselectionElm?.clientHeight || 0);
                        const headerHeight = GT.mainHeaderElm?.clientHeight || 0;
                        
                        // Write phase - all style updates at once
                        const style = document.documentElement.style;
                        style.setProperty('--top-banner-msg-height', bannerHeight + 'px');
                        style.setProperty('--main-header-height', headerHeight + 'px');
                        style.setProperty('--scrollbar-width', GT.scrollbarWidth + 'px');
                        style.setProperty('--window-height', GT.wHeight + 'px');
                        
                        // Store for other code that might need these values
                        GT.mainHeaderElmHeight = headerHeight;
                    });
                }

                //performance issue
                // if(GT.scrollTop() < 100 && !location.hash)
                //     window.scrollTo(0,0);
            }, 50)
        })
    }

    let desktopLogo = document.querySelector(".desktop-logo img");
    if(desktopLogo) {
        desktopLogo.onload = function(){
            triggerFunctionsAfterMainLogoLoaded();
        }
        desktopLogo.onerror = function(){
            triggerFunctionsAfterMainLogoLoaded();
        }
        if(desktopLogo.complete) {
            triggerFunctionsAfterMainLogoLoaded();
        }
    } else
        triggerFunctionsAfterMainLogoLoaded();

	GT.announceArea = document.querySelector(".announce-area");
    
	initTabPanelActionHandler();
    
    if(typeof isV1GT == "undefined") {
        GT.isTouchDevice = GT.isTouchDevice();
        GT.domContentLoadedFncList.forEach(function(fnc){
            try {
                requestAnimationFrame(() => {
                    fnc();
                });
            } catch (e) {
                console.log(e);
            }
        })
    }
});

let isOrientationChange = false;
if(window.screen.orientation)
    window.screen.orientation.addEventListener('change', function(){
        isOrientationChange = true;
    });
else
    window.addEventListener("orientationchange", function() {
        isOrientationChange = true;
    });

GT.recalculateHeaderHeight = function(timeout = 500){
    setTimeout(function(){
        let bannerMsgHeight = 0;
        
        requestAnimationFrame(() => {
            bannerMsgHeight += GT.topBannerMsgElm ? GT.topBannerMsgElm.clientHeight : 0;
            bannerMsgHeight += GT.countryPreselectionElm ? GT.countryPreselectionElm.clientHeight : 0;
            GT.mainHeaderElmHeight = GT.mainHeaderElm ? GT.mainHeaderElm.clientHeight : 0;
            
            if(GT.headerElm) {
                GT.stickyHeaderOffsetTop = GT.headerElm.firstElementChild.offsetHeight - (GT.isMobileView() ? 64 : 88);
                GT.headerElmHeight = GT.headerElm.clientHeight;
            }
        });

        requestAnimationFrame(() => {
            document.documentElement.style.setProperty('--top-banner-msg-height', bannerMsgHeight + 'px');
            document.documentElement.style.setProperty('--main-header-height', GT.mainHeaderElmHeight + 'px');
            document.documentElement.style.setProperty('--header-height', GT.headerElmHeight + 'px');
        });

    }, timeout)
}

window.addEventListener("resize", function(){
    requestAnimationFrame(() => {
        GT.wHeight = window.innerHeight;
        GT.wWidth = window.innerWidth;
        GT.bodyWidth = document.body.clientWidth;
        GT.scrollbarWidth = GT.wWidth - GT.bodyWidth;
    });

    requestAnimationFrame(() => {
        document.documentElement.style.setProperty('--scrollbar-width', GT.scrollbarWidth + 'px');
        document.documentElement.style.setProperty('--window-height', GT.wHeight + 'px');
    });

    GT.recalculateHeaderHeight();
    GT.isMobileCached = GT.isMobile();
});

window.addEventListener("resize", GT.debounce(function(){
    //resize event always fires in Mobile browser if scrolling, because of browser's menu bar
    if(!GT.isMobileCached || isOrientationChange) {
        GT.hideHyperLinkAnimation();
        Object.keys(GT.windowResizeFncList).forEach(function(k) {
            if(typeof GT.windowResizeFncList[k] == "function")
                GT.windowResizeFncList[k]();
        })
        GT.recalculateHeaderHeight();
    }
    isOrientationChange = false;
}, 250));

document.addEventListener('touchmove', function(e){
    Object.keys(GT.touchMoveFncList).forEach(function(k) {
        GT.touchMoveFncList[k](e);
    })
}, {passive: false});